import xor from 'lodash/xor';

function getObjectDiff(object1, object2) {
	const properties = [...new Set([...Object.keys(object1), ...Object.keys(object2)])];
	const changedProperties = properties.reduce((diff, key) => {
		if (Array.isArray(object2[key]) && xor(object2[key], object1[key]).length === 0) {
			return diff;
		}

		if (object2[key] === object1[key]) {
			return diff;
		}

		return {
			...diff,
			[key]: object1[key],
		};
	}, {});

	return changedProperties;
}

function deepCloneObject(object) {
	return JSON.parse(JSON.stringify(object));
}

export { getObjectDiff, deepCloneObject };
